export default __webpack_public_path__ + "static/media/illustration-dark-theme.9b797bbe.svg";